<div class="media profile-media">
  <img class="b-r-10" src="assets/images/dashboard/profile.jpg" alt="">
  <div class="media-body"><span>{{user?.name}}</span>
    <p class="mb-0 font-roboto">{{user?.type}} <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <!-- <li><a href="#"><app-feather-icons [icon]="'user'"></app-feather-icons><span>Profile </span></a></li> -->
  <li><a   (click)="logoutUser()"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Log out</span></a></li>
</ul>